/**
 * Shared between the server and the browser: account API shapes and the exact
 * consent wording (the consent log stores this text, so changing it is fine:
 * old rows keep the wording people actually agreed to).
 */

/** Marketing emails need their own unchecked box (Israeli spam law §30A, GDPR). */
export const MARKETING_CONSENT =
  'Email me about new Combinator features and sound packs for sale (advertising). One email a month at most; unsubscribe anytime.';

export const CODE_LENGTH = 6;
export const CODE_TTL_MIN = 10;
export const MAX_SONG_BYTES = 2_000_000;
export const MAX_SONGS = 100;

export interface Me {
  email: string;
  marketing: boolean;
  createdAt: number;
}

export interface SongMeta {
  id: string;
  name: string;
  size: number;
  updatedAt: number;
}

/** What /api/info tells the browser about this server. */
export interface ServerInfo {
  lan: string[];
  https: boolean;
  platform: string;
  port: number;
  /** Public website mode: licensed sounds only, hosts sign in. */
  public: boolean;
  authRequired: boolean;
  publicUrl: string;
  donateUrl: string;
  contactEmail: string;
  operator: string;
  /** Who hosts the server and where, for the privacy notice. */
  hosting: string;
}

export const isEmail = (s: string) => s.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s);
export const normEmail = (s: string) => s.trim().toLowerCase();
